/**
 * Check model
 */

export class Check {
    CondType: string = "CT_Uninitialized";
    CkType: string = "CT_Uninitialized";
    ConditionStep2: string = "";
    ConditionStep3: string = "";
    ConditionStep4: string = "";
}

export function SetupCheckData(GameData: any[]): Check {
    const CurCheck = new Check();
    CurCheck.CondType = GameData[0];
    CurCheck.CkType = GameData[1];
    CurCheck.ConditionStep2 = GameData[2];
    CurCheck.ConditionStep3 = GameData[3];
    CurCheck.ConditionStep4 = GameData[4];
    return CurCheck;
}
